import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const AppContainer = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "app-container" */ './app-container')),
});
